/*
 * @Author: your name
 * @Date: 2020-06-05 11:06:15
 * @LastEditTime: 2020-06-10 16:45:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \esign-landing\src\views\common\components\mixins\qiyu.js
 */

// 七鱼客服
export default {
  methods: {
    addQiyuScript() {
      /* eslint-disable */
      ;(function(w, d, n, a, j) {
        w[n] =
          w[n] ||
          function() {
            ;(w[n].a = w[n].a || []).push(arguments)
          }
        j = d.createElement('script')
        j.async = true
        j.src = 'https://qiyukf.com/script/e7172fc844d88cd3ae196678ea38da5e.js?hidden=1'
        d.body.appendChild(j)

        j.onload = function() {
          window.ysf('config', {
            uid: '', // 用户ID
            groupid: '397595188', // 客服组ID
            data: JSON.stringify([
              { key: 'real_name', value: '' }, // 姓名
              { key: 'mobile_phone', value: '' }, // 手机号
              { key: 'email', value: '' }, // 邮箱
              { key: 'address', value: '' }, // 地址
              { type: 'crm_param', key: '', value: '' }, // 自定义字段(sourceType): USER - 注册用户; PURCHASER - 管理员录入
            ]),
          })
        }
      })(window, document, 'ysf')
      /* eslint-enable */
    },

    /**
     *打开客服弹窗
     */
    handleCustomerServiceClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        // eslint-disable-next-line camelcase
        window.meteor && window.meteor.track && window.meteor.track('consult_effective', { convert_id: '1655145710006284' })
      }
      this.$tsignData.track('click_customer_service')
      this.$tsignData.track('sign_landingpage_onlineservice')

      // // 登出客服系统
      // window.ysf('logoff')

      // window.ysf('open', {
      //   uid: '', // 用户ID
      //   groupid: '397595188', // 客服组ID
      //   data: JSON.stringify([
      //     { key: 'real_name', value: '' }, // 姓名
      //     { key: 'mobile_phone', value: '' }, // 手机号
      //     { key: 'email', value: '' }, // 邮箱
      //     { key: 'address', value: '' }, // 地址
      //     { type: 'crm_param', key: '', value: '' }, // 自定义字段(sourceType): USER - 注册用户; PURCHASER - 管理员录入
      //   ]),
      // })

      window.ysf('config', {
        groupid: '397595188',
        success() {
          if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
            // 移动端
            window.location.href = window.ysf('url')
          } else {
            // pc端
            window.ysf('open')
          }
        },
      })
    },

    /*
     * 20240613 开始替换百度爱番番的在线咨询客服
     */
    handleNewBaiduService() {
      this.$tsignData.track('click_customer_service')
      this.$tsignData.track('sign_landingpage_onlineservice')
      const url =
        'https://ada.baidu.com/site/wjzq4si7/agent?imid=93f93a5d065df292082d8b2c1471a571&ch=90&sch=0&wid=4b534c47-78f5-4e1c-33b0-172412350423_0_0&queryPathKey=%2Fbot#merchant_bot_layer&utm_source=sem**baidu**in百度付费'
      window.open(url, 'kefuWindow', `height=660,width=1200,top=-150,left=${this.$store.state.user.left}`)
    },
  },
}
